export class Tool {
  create() {}

  draw() {}

  done() {}
}
